import React, { lazy, Suspense } from 'react';
import { useAgencyCapabilities } from '../../shared/agency/AgencyEntry';
import './storeAgency.css';

const Workspace = lazy(() => import('./StoreAgencyWorkspace'));
export default function StoreAgencyEntry({ onBack, initialTab = 'shipments', onSupport }) {
  const caps = useAgencyCapabilities();
  return <div className="store-agency-shell"><div className="store-agency">
    <header className="sa-header"><button onClick={onBack}>← Volver</button><span>FAST MAX · AGENCIAS</span></header>
    {!caps ? <p role="status">Consultando acceso…</p> : !caps.enabled || caps.role !== 'store' ?
      <section className="sa-card"><h1>Envíos por agencia</h1><p>Este servicio aún no está habilitado para tu tienda. Tus entregas actuales siguen disponibles.</p></section> :
      <Suspense fallback={<p role="status">Cargando tus envíos…</p>}><Workspace caps={caps} initialTab={initialTab} onSupport={onSupport} /></Suspense>}
  </div></div>;
}
